import { useTranslation } from '@blocs.i18n';

type GetRepShortCodeArgs = {
  skip: boolean;
  isFastCastProfile?: boolean;
  isPersonalProfile: boolean;
  organizations?: any;
};

type GetRepShortCodeResult = string | void;

export const useRepShortCode = () => {
  const { t } = useTranslation();

  return ({
    skip,
    isFastCastProfile,
    isPersonalProfile,
    organizations,
  }: GetRepShortCodeArgs): GetRepShortCodeResult => {
    if (skip) return null;

    if (isFastCastProfile) return t('common:label.notOnCastingNetwork');

    if (isPersonalProfile) return t('common:label.personalProfile');

    if (Array.isArray(organizations) && organizations.length) {
      const [firstOrganization] = organizations;

      return firstOrganization && firstOrganization.abbreviation;
    }

    return null;
  };
};
